forestControllers.controller('authController', function($scope, $state, $rootScope, User, $cacheFactory) {

    $scope.loginData = {};

    $scope.badCredentials = false;

    $scope.submitLogin = function() {
        //
        User.login($scope.loginData).success(function(data) {
            if (data['msg'] === 'Ok')
            {
                $rootScope.authed = data['data'];
                $scope.badCredentials = false;
                //alert("Good message redirect will happen right now");
                $state.go('app.welcome');
            } else {
                $scope.badCredentials = true;
            }
        }).error(function(data) {
            //alert(JSON.stringify(data));
        });
    };
});